import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuStateService {
  sections: any[] = [];
  dishes: any[] = [];
  copyMenu: any[] = [];
  restaurant: any;
  hasFilter: boolean = false;
  idDish?: number;
  idRestaurant?: number;
  idMenu?: number;
  menudId?: number;
  icons: any;
}
